app.filter('translated', ['$translate', function($translate){
    function f(input) {
        var lang = $translate.use();
        var defaultlang = $translate.preferredLanguage();

        var t = input[lang] || input[defaultlang];
        t = t || input['en'];

        return t;
    }

    f.$stateful = true;

    return f;
}]);
